// extracted by mini-css-extract-plugin
export var link = "_sa-0";